import { render, staticRenderFns } from "./DocumentFieldMarker.vue?vue&type=template&id=4ac8a018&scoped=true"
import script from "./DocumentFieldMarker.vue?vue&type=script&lang=js"
export * from "./DocumentFieldMarker.vue?vue&type=script&lang=js"
import style0 from "./DocumentFieldMarker.vue?vue&type=style&index=0&id=4ac8a018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8a018",
  null
  
)

export default component.exports